import React from "react";
import {AuthAdmin, AuthManagerAdmin, AuthSuperAdmin, AuthTeacher} from "../api";
import { Url} from "./authsUrls";


const Files = React.lazy(
    () => import("../pages/Teachers/File/FileLists"))
const FileDetail = React.lazy(
    () => import('../pages/Teachers/File/FileDetails'))

const TeacherClass = React.lazy(
    () => import("../pages/Teachers/TeacherClass/TeacherClass")
)
const TeacherClassDetail = React.lazy(
    () => import("../pages/Teachers/TeacherClass/TeacherClassDetail")
)
const HomeworkDetailPage = React.lazy(
    () => import("../pages/Teachers/TeacherClass/HomeworkDetailPage")
)
const HomeworkGradingPage = React.lazy(
    () => import("../pages/Teachers/TeacherClass/HomeworkGradingPage")
)
const StudentHomeworkGradePage = React.lazy(
    () => import("../pages/Teachers/TeacherClass/StudentHomeworkGradePage")
)
const Course = React.lazy(
    () => import('../pages/Teachers/Course/CourseView'))
const CourseManager = React.lazy(
    () => import('../pages/Teachers/Course/CourseViewManager'))

const Working = React.lazy(
    () => import('../pages/Teachers/Working/Working'))
const NewWorking = React.lazy(
    () => import('../pages/Teachers/Working/NewWorkings'))
const MyWorkingTable = React.lazy(
    () => import('../pages/Teachers/Working/MyWorkingTable'))

const WorkingManager = React.lazy(
    () => import('../pages/Teachers/Working/WorkingManager'))



const QuestionBankList = React.lazy(
    () => import("../pages/Teachers/TeacherAssessment/AdminQuestionBank"))

const QuestionBankDetail = React.lazy(
    () => import("../pages/Teachers/TeacherAssessment/AdminQuestionBankDetail"))

const AdminPaperTaskList = React.lazy(
    () => import("../pages/Teachers/TeacherAssessment/AdminPaperTask")
)


const AdminPaperTaskDetail = React.lazy(
    () => import("../pages/Teachers/TeacherAssessment/AdminPaperTaskDetails")
)
const UserPaperRun = React.lazy(
    () => import("../pages/Teachers/TeacherAssessment/UserPaperRun"))


const UserPaperList = React.lazy(
    () => import("../pages/Teachers/TeacherAssessment/UserPaperList")
)

const HomeworkBankList = React.lazy(
    () => import("../pages/Teachers/HomeworkBank/HomeworkBankList")
)

const HomeworkBankTempList = React.lazy(
    () => import("../pages/Teachers/HomeworkBank/HomeworkBankTempList")
)

const HomeworkBankTempDetail = React.lazy(
    () => import("../pages/Teachers/HomeworkBank/HomeworkBankTempDetail")
)



const ClassManager = React.lazy(
    () => import("../pages/Teachers/ManagerTeacherAdmin/ClassManager/ClassManager")
)

export const TeacherUrls: Url[] = [
    {Uri: "/teacher/class/manager", Comp: ClassManager, Auth: [AuthManagerAdmin, AuthSuperAdmin], Layout: true},
    {Uri: "/teacher/class", Comp: TeacherClass, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/class/:classId", Comp: TeacherClassDetail, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/class/:classId/homework/:homeworkID", Comp: HomeworkDetailPage, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/class/:classId/homework/:homeworkID/grade/:studentId", Comp: StudentHomeworkGradePage, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/grade", Comp: HomeworkGradingPage, Auth: [AuthTeacher], Layout: true},

    {Uri: "/teacher/files", Comp: Files, Auth: [AuthTeacher], Layout: true},
    {Uri: '/teacher/file/:id', Comp: FileDetail, Auth: [AuthTeacher], Layout: false},

    {Uri: "/teacher/courses", Comp: Course, Auth: [AuthTeacher], Layout: true},
    {
        Uri: "/teacher/courses/manager",
        Comp: CourseManager,
        Auth: [AuthAdmin, AuthManagerAdmin, AuthSuperAdmin],
        Layout: true
    },
    // {Uri: "/test", Comp: Test, Auth: [], Layout: true},

    {Uri: "/teacher/working", Comp: Working, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/working/new", Comp: NewWorking, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/working/table", Comp: MyWorkingTable, Auth: [AuthTeacher], Layout: true},

    {Uri: "/teacher/working/manager", Comp: WorkingManager, Auth: [AuthManagerAdmin, AuthSuperAdmin], Layout: true},

    {Uri: "/teacher/questionBank", Comp: QuestionBankList, Auth: [AuthManagerAdmin, AuthSuperAdmin], Layout: true},
    {
        Uri: "/teacher/questionBank/:bankId",
        Comp: QuestionBankDetail,
        Auth: [AuthManagerAdmin, AuthSuperAdmin],
        Layout: true
    },
    {Uri: "/teacher/paperTask", Comp: AdminPaperTaskList, Auth: [AuthManagerAdmin, AuthSuperAdmin], Layout: true},
    {
        Uri: "/teacher/paperTask/:taskId",
        Comp: AdminPaperTaskDetail,
        Auth: [AuthManagerAdmin, AuthSuperAdmin],
        Layout: true
    },

    {Uri: "/teacher/papers", Comp: UserPaperList, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/paper/exam/:paperId", Comp: UserPaperRun, Auth: [AuthTeacher], Layout: true},

    {Uri: "/teacher/homeworkBank", Comp: HomeworkBankList, Auth: [AuthTeacher], Layout: true},
    {Uri: "/teacher/homeworkBank/:bankID/index", Comp: HomeworkBankTempList, Auth: [AuthTeacher], Layout: true},
    {
        Uri: "/teacher/homeworkBank/:bankID/temps/:tempID",
        Comp: HomeworkBankTempDetail,
        Auth: [AuthTeacher],
        Layout: true
    },
    {Uri: "/teacher/homeworkBank/:bankID/temps/new", Comp: HomeworkBankTempDetail, Auth: [AuthTeacher], Layout: true},
]
